import { inject } from '@angular/core';
import { CanMatchFn, Route } from '@angular/router';
import { FeatureFlagService } from '@core/services/feature-flag/feature-flag.service';
import { FeatureFlagsEnum } from '@generated/featureFlags.enum';

export const featureFlagGuard: CanMatchFn = (route: Route) => {
  const featureFlagSvc = inject(FeatureFlagService);

  const flags = route.data?.['flags'] as FeatureFlagsEnum[];

  return flags.every((flag) => featureFlagSvc.featureFlagMap.get(flag)?.active);
};
